import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';
import { ToggleSwitch } from '../../../Form';
import PopupV3 from '../../../Popup/PopupV3';

const EnablePreRegToggle = (props) => {
    const {
        field,
        formApi,
    } = props;

    const [showPopup, setShowPopup] = useState(false);

    return (
        <>
            <div className={`col-12`}>
                <ToggleSwitch
                    id={'preRegAndEligibleListEnabled'}
                    field={field}
                    formGroupCssClass={`mb16`}
                    label={'Enable pre-registration & eligible player list restrictions'}
                    isEventEditForm

                    onChange={(val) => {
                        if (!val) {
                            formApi.setValue('preRegAndEligibleListEnabled', false);
                            formApi.setError(false);
                        }
                        if (val) {
                            setShowPopup(true);
                        }
                    }}
                    reverse={false}
                />
                <div className="div div16" />
            </div>
            <PopupV3
                title="Enable pre-registration & eligible player list restrictions"
                message="By enabling these restrictions, providers can selectively exempt specific divisions from eligibility requirements."
                confirmButtonLabel="Enable"
                onConfirmClick={() => {
                    formApi.setValue('preRegAndEligibleListEnabled', true);
                    setShowPopup(false);
                }}
                showCancelButton
                cancelButtonLabel="Cancel"
                onCancelClick={() => {
                    formApi.setValue('preRegAndEligibleListEnabled', false);
                    setShowPopup(false);
                }}
                isOpen={showPopup}
                noIcon
            />
        </>
    );
};
EnablePreRegToggle.propTypes = {
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
};
export default EnablePreRegToggle;
